export default [{
  path: '/recover/:token',
  name: 'recover',
  component: function component() {
    return import('pages/Recover.vue');
  }
}, {
  path: '/confirmacion-de-cuenta/:token',
  name: 'confirm',
  component: function component() {
    return import('pages/Confirm.vue');
  }
}];